
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Award } from 'lucide-react';

interface ProfileHeaderProps {
  totalSOSEvents?: number;
}

const ProfileHeader = ({ totalSOSEvents = 0 }: ProfileHeaderProps) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
  };

  // Calculate how many badges the user has earned
  const getEarnedBadgesCount = (sosEvents: number) => {
    const badgeThresholds = [1, 5, 10, 25];
    return badgeThresholds.filter(threshold => sosEvents >= threshold).length;
  };

  const earnedBadges = getEarnedBadgesCount(totalSOSEvents);

  return (
    <div className="bg-white shadow-sm p-4">
      <div className="container mx-auto max-w-4xl">
        <div className="flex items-center justify-between">
          <Button 
            variant="outline" 
            onClick={handleBackClick}
            className="flex items-center space-x-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </Button>
          <h1 className="text-xl font-semibold text-center">Your Progress</h1>
          <div className="flex items-center">
            <div className="flex items-center bg-cream px-3 py-1 rounded-full">
              <Award className="h-4 w-4 text-amber-500 mr-1" />
              <span className="text-sm font-medium">{earnedBadges} badges</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
